// API base URL.
// - Local dev (vite dev server): use the relative `/api` so Vite's proxy
//   forwards to localhost:7071 (see vite.config.ts).
// - Production (commercial.majans.com or any *.azurestaticapps.net): call
//   the Function App directly. SWA's backend-link feature is unavailable
//   on Functions Consumption plans, so cross-origin via CORS is the path.
//
// Optional override via VITE_API_URL still wins if set (kept for tooling /
// staging slots), but we no longer rely on it being present.
const PROD_API = 'https://commercial-api-v1.azurewebsites.net/api';

function resolveApiBase(): string {
  const fromEnv = import.meta.env.VITE_API_URL;
  if (fromEnv) return fromEnv;
  if (typeof window === 'undefined') return PROD_API;
  const host = window.location.hostname;
  // Dev — let Vite proxy handle it.
  if (host === 'localhost' || host === '127.0.0.1') return '/api';
  // Production: SWA hostnames + custom domain.
  return PROD_API;
}

export const API_BASE_URL = resolveApiBase();
